export const waitUntilAllowed = async (
  check: () => boolean,
  interval = 2000,
) => {
  while (!check()) {
    await new Promise((res) => setTimeout(res, interval))
  }
}
